import React from "react";
import { ReactComponent as LinkedinIcon } from "Assets/svg/linkedin.svg";

// Shared identity primitives for the approval popup + research card so both
// surfaces render the contact the same way: same letter, same color from the
// same hash, same LinkedIn brand mark.

const avatarLetterFor = (s) =>
  (String(s || "?").trim().charAt(0) || "?").toUpperCase();

// Deterministic 1..6 bucket so the same contact always gets the same color.
const avatarClassFor = (s) => {
  const str = String(s || "");
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return `c${((h % 6) + 6) % 6 + 1}`;
};

// Normalize whatever shape a LinkedIn URL is stored in (full URL,
// "linkedin.com/in/foo", or bare username) into a clickable absolute URL.
export const normalizeLinkedInUrl = (raw) => {
  if (!raw || typeof raw !== "string") return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.includes("linkedin.com")) return `https://${trimmed}`;
  return `https://www.linkedin.com/in/${trimmed}`;
};

export const LetterAvatar = ({ seed, size = "md", className = "" }) => (
  <div
    className={`drApprovalAvatar drApprovalAvatar--${avatarClassFor(seed)} drApprovalAvatar--${size} ${className}`}
    aria-hidden="true"
  >
    {avatarLetterFor(seed)}
  </div>
);

export const LinkedInBadge = ({ url, className = "" }) => {
  const normalized = normalizeLinkedInUrl(url);
  if (!normalized) return null;
  return (
    <a
      className={`drLinkedInBrandLink ${className}`}
      href={normalized}
      target="_blank"
      rel="noopener noreferrer"
      title="Open LinkedIn profile"
      onClick={e => e.stopPropagation()}
    >
      <LinkedinIcon />
    </a>
  );
};
